import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {
  dashboardLayoutRoutes,
  authLayoutRoutes,
  protectedRoutes,
} from "./index";

import DashboardLayout from "../layouts/Dashboard";
import AuthLayout from "../layouts/Auth";
import Page404 from "../pages/auth/Page404";
import PickerOrderPage from "../pages/PickerOrder/PickerOrderPage/PickerOrderPage";
import PickerOrderProcess from "../pages/PickerOrder/PickerOrderProcess.js/PickerOrderProcess";
import MissingZone from "../pages/PickerOrder/MissingZone/MissingZone";
import CheckerOrderPage from "../pages/MarkOrder/CheckerOrderPage/CheckerOrderPage";
import TOPOProcess from "../pages/TOPicker/TOPOProcessPage/TOPOProcess";
import TOPOPage from "../pages/TOPicker/TOPOPage/TOPOPage";
import TOCheckerOrderPage from "../pages/TOChecker/TOCheckerOrderPage/TOCheckerOrderPage";
import TOCheckerOrder from "../pages/TOChecker/TOCO/TOCheckerOrder";
import TOCOBoxProcess from "../pages/TOChecker/TOCOBoxProcess/TOCOBoxProcess";
import ToBoxChecker from "../components/Transfer Order/ToChecker/ToBoxChecker";
import TOPOFinalScreen from "../pages/TOPicker/TOPOPage/components/PickerFinalScreen/TOPOFinalScreen";
import TOBPMain from "../pages/TOBinTransfer/TOBinPicker/TOBPMain/TOBPMain";
import BinTable from "../pages/TOBinTransfer/components/BinTable/BinTable";
import ToBinRackerPage from "../pages/TOBinTransfer/ToBinRacker/ToBinRackerPage/ToBinRackerPage";
import ToBinRacking from "../pages/TOBinTransfer/ToBinRacker/ToBinRacking/ToBinRacking";
import TOBPMed from "../pages/TOBinTransfer/TOBinPicker/TOBPMed/TOBPMed";
import PutAwayItems from "../pages/putAway/putAwayItems/PutAwayItems";
import PutAwayInvoices from "../pages/putAway/PutAwayInvoices/PutAwayInvoices";
import PackSlip from "../pages/PackSlip";
import PrintPackslip from "../pages/PackSlip/PrintPackslip";

const childRoutes = (Layout, routes) =>
  routes.map(({ component: Component, guard, children, path }, index) => {
    const Guard = guard || React.Fragment;

    return children ? (
      children.map((element, index) => {
        const Guard = element.guard || React.Fragment;

        return (
          <Route
            key={index}
            path={element.path}
            exact
            render={(props) => (
              <Guard>
                <Layout>
                  <element.component {...props} />
                </Layout>
              </Guard>
            )}
          />
        );
      })
    ) : Component ? (
      <Route
        key={index}
        path={path}
        exact
        render={(props) => (
          <Guard>
            <Layout>
              <Component {...props} />
            </Layout>
          </Guard>
        )}
      />
    ) : null;
  });

const Routes = () => (
  <Router basename={process.env.PUBLIC_URL}>
    <Switch>
      {childRoutes(DashboardLayout, dashboardLayoutRoutes)}
      {childRoutes(DashboardLayout, protectedRoutes)}
      {childRoutes(AuthLayout, authLayoutRoutes)}

      <Route
        path="/picker-order/:orderId"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <PickerOrderPage />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />

      <Route
        path="/MissingZone/:orderId/:rackNumber"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <MissingZone />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />

      <Route
        path="/picker-order-process/:orderId"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <PickerOrderProcess />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />

      <Route
        path="/to-picker-order-process/:TOID"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <TOPOProcess />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />

      <Route
        path="/to-checker-order-process/:TOID"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <ToBoxChecker />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />

      <Route
        path="/to-checker-box-process/:TOID"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <TOCOBoxProcess />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />

      <Route
        path="/to-picker-order/:TOID"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <TOPOPage />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />

      <Route
        path="/checker-order/:orderId"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <CheckerOrderPage />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />

      <Route
        path="/to-bin-picker"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <TOBPMain />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />

      <Route
        path="/to-bin-picking"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <TOBPMed />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />
      <Route
        path="/to-bin-racker"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <ToBinRackerPage />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />
      <Route
        path="/to-bin-racking"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <ToBinRacking />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />
      <Route
        path="/put-away-invoices"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <PutAwayInvoices />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />
      <Route
        path="/put-away-racking/:vendorId/:billNumber"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <PutAwayItems />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />
      <Route
        path="/to-checker-order/:toId/:boxId"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <TOCheckerOrderPage />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />

      <Route
        path="/picker-final-screen"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <TOPOFinalScreen />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />

      <Route
        path="/to-container-packing"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <PackSlip />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />

      <Route
        path="/print-pack-slip"
        render={() => (
          <React.Fragment>
            <DashboardLayout>
              <PrintPackslip />
            </DashboardLayout>
          </React.Fragment>
        )}
        exact
      />

      <Route
        render={() => (
          <AuthLayout>
            <Page404 />
          </AuthLayout>
        )}
      />
    </Switch>
  </Router>
);

export default Routes;
